import React from 'react';
import { Market } from '../types';
import { Periodicity } from '@ecosystem/newron-core/types';
import { actions, elements } from '@ecosystem/newron-design-system';

const { Button } = actions;
const { Icon } = elements;

type Props = {
  isLoading: boolean;
  markets: Market[];
  periodicity: Periodicity;
  onRemoveNonSubscribed: (markets: Market[]) => void;
};
function MissingSubscriptions({ isLoading, markets, periodicity, onRemoveNonSubscribed }: Props) {
  const affectedMarkets = markets.filter(m => !m.periods.find(p => p.periodicity === periodicity));

  const handleRemove = () => {
    onRemoveNonSubscribed(affectedMarkets);
  };

  return (
    <div className="py-6 px-4 overflow-y-auto overscroll-contain">
      {markets.length === affectedMarkets.length && (
        <div className="text-sm flex flex-column gap-2">
          <Icon color="info">
            <Icon.icons.Info />
          </Icon>
          <span>{periodicity} periods are not available due to your current subscription.</span>
          <span className="text-xs">Need this data? Please contact your account manager to discuss your options.</span>
        </div>
      )}
      {markets.length > affectedMarkets.length && (
        <>
          <div className="text-heading font-bold flex gap-2">
            <Icon color="info">
              <Icon.icons.Info />
            </Icon>
            <span>Missing subscriptions</span>
          </div>
          <div className="text-sm mt-4">
            A subscription to {periodicity} data is missing for <b>{affectedMarkets.length}</b> of your{' '}
            <b>{markets.length}</b> selected markets.
          </div>
          <div className="my-4">
            {affectedMarkets.slice(0, 5).map(m => (
              <div className="text-xs font-bold" key={m.value}>
                {m.label}
              </div>
            ))}
            {affectedMarkets.length > 5 && (
              <span className="text-lighter text-xs">+ {affectedMarkets.length - 5} more</span>
            )}
          </div>
          <div className="text-sm">
            Do you want to remove the affected markets from your selection so you can view {periodicity} data?
          </div>
          <div className="pt-4 flex justify-center">
            <Button disabled={isLoading} onClick={handleRemove}>
              Yes, remove them
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export { MissingSubscriptions };
